import { IEarningSummaryItem } from '@app/models/EarningSummaryItem'
import {
  formatAddressSingleLine,
  formatCurrency,
  formatDate,
} from '@app/utils/formatting'
import { List } from 'immutable'
import * as React from 'react'

interface IComponentProps {
  reportData: List<IEarningSummaryItem>
}

export default class EarningsReportRenderer extends React.PureComponent<
  IComponentProps
> {
  public render() {
    return this._renderReport()
  }

  public _renderReport() {
    if (!this.props.reportData) {
      return 'No Earnings Data'
    }

    const items: any = []
    const grandTotals = {
      commission: 0,
      listing: 0,
      selling: 0,
    }
    this.props.reportData.map((a?: IEarningSummaryItem, aIdx?: number) => {
      if (!a || aIdx === undefined) {
        return null
      }

      grandTotals.commission += a.totalCommission

      items.push(
        <div
          key={`earning-item-${aIdx}`}
          className={`d-flex flex-row justify-content-around ${
            aIdx % 2 === 0 ? 'striped-row' : ''
          }`}
          style={{ minHeight: '100px' }}
        >
          <div
            className='col'
            style={{ wordBreak: 'break-word', minWidth: '100px' }}
          >
            {a.brokerName}
          </div>
          <div
            style={{
              minHeight: '100px',
              minWidth: '100px',
              wordBreak: 'break-word',
            }}
            className='d-none d-lg-flex flex-column col '
          >
            <div>{a.property.name}</div>
            <div className='text-muted' style={{ fontSize: '0.775rem' }}>
              {formatAddressSingleLine(a.property.address)}
            </div>
          </div>
          <div className='col'>{formatDate(a.closingDate, 'MM/DD/YYYY')}</div>
          <div className='col'>{formatCurrency(a.saleLeasePrice, 2)}</div>
          <div className='col d-none d-lg-block'>{a.buyerTenant}</div>
          <div className='col'>{formatCurrency(a.totalCommission, 2)}</div>
          <div
            className='d-flex flex-column col'
            style={{ fontSize: '0.775rem' }}
          >
            {a.listingAgentAmounts && a.listingAgentAmounts.size > 0
              ? a.listingAgentAmounts.map((listing: any, idx: any) => {
                  if (listing.contact) {
                    grandTotals.listing +=
                      a.saleLeasePrice *
                      (a.listingFeePercent / 100) *
                      (listing.amount / 100)
                    return (
                      <div key={`listing-agent-${idx}`} className={`${idx > 0 ? 'mt-2' : ''}`}>
                        <div>{listing.contact.name}</div>
                        <div className='text-muted'>
                          {formatCurrency(
                            a.saleLeasePrice *
                              (a.listingFeePercent / 100) *
                              (listing.amount / 100),
                            2,
                          )}
                        </div>
                      </div>
                    )
                  } else {
                    return <div key={`listing-agent-${idx}`}>No agent</div>
                  }
                })
              : 'No agents'}
          </div>
          <div
            className='d-flex flex-column col'
            style={{ fontSize: '0.775rem' }}
          >
            {a.sellingAgentAmounts && a.sellingAgentAmounts.size > 0
              ? a.sellingAgentAmounts.map((selling: any, idx: any) => {
                  if (selling.contact) {
                    grandTotals.selling +=
                      a.saleLeasePrice *
                      (a.listingFeePercent / 100) *
                      (selling.amount / 100)
                    return (
                      <div key={`selling-agent-${idx}`} className={`${idx > 0 ? 'mt-2' : ''}`}>
                        <div>{selling.contact.name}</div>
                        <div className='text-muted'>
                          {formatCurrency(
                            a.saleLeasePrice *
                              (a.sellingFeePercent / 100) *
                              (selling.amount / 100),
                            2,
                          )}
                        </div>
                      </div>
                    )
                  } else {
                    return <div key={`selling-agent-${idx}`}>No agent</div>
                  }
                })
              : 'No agents'}
          </div>
        </div>,
      )
    })

    return (
      <section>
        <div
          className='d-flex flex-row justify-content-around'
          style={{ fontWeight: 'bold' }}
        >
          <div className='col'>Broker</div>
          <div className='col d-none d-lg-block'>Property</div>
          <div className='col'>Close Date</div>
          <div className='col'>Sale/Lease $</div>
          <div className='col d-none d-lg-block'>Buyers/Tenants</div>
          <div className='col'>Commission</div>
          <div className='col'>Listing</div>
          <div className='col'>Selling</div>
        </div>
        {items}
        <div
          className='d-flex flex-row justify-content-around'
          style={{ fontWeight: 'bold' }}
        >
          <div className='col'>Grand Totals</div>
          <div className='col d-none d-lg-block' />
          <div className='col' />
          <div className='col' />
          <div className='col d-none d-lg-block' />
          <div className='col'>{formatCurrency(grandTotals.commission, 2)}</div>
          <div className='col'>{formatCurrency(grandTotals.listing, 2)}</div>
          <div className='col'>{formatCurrency(grandTotals.selling, 2)}</div>
        </div>
      </section>
    )
  }
}
